const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const {ChooseOptionModal} = require("./modals/ChooseOptionModal");

const styles = require("./styles/ToggleItem.css");

module.exports = createReactClass({
	displayName: "ToggleItem",

	propTypes: {
		className: PT.string,
		confirmOffWarning: PT.string,
		handleClick: PT.func,
		onToggle: PT.func,
		isOn: PT.bool,
	},

	getInitialState: function() {
		return {
			showConfirm: false,
		};
	},

	onKeyPress: function(evt) {
		if (evt.which !== 13 && evt.which !== 32) {
			return;
		}
		evt.preventDefault();
		this.onToggle();
	},

	onToggle: function() {
		const newIsOn = !this.props.isOn;
		if (this.props.confirmOffWarning && !newIsOn) {
			this.setState({showConfirm: true});
		} else {
			this.setToggleState(newIsOn);
		}
		this.props.handleClick && this.props.handleClick();
	},

	setToggleState: function(isOn) {
		this.setState({showConfirm: false});
		this.props.onToggle && this.props.onToggle(isOn);
	},

	closeConfirm: function() {
		this.setState({showConfirm: false});
	},

	render: function() {
		const {isOn, className, confirmOffWarning} = this.props;
		const {showConfirm} = this.state;
		let mainClass = isOn ? styles.on : styles.off;
		if (className) mainClass += " " + className;
		let confirmModal = null;
		if (showConfirm) {
			confirmModal = (
				<ChooseOptionModal
					message={confirmOffWarning}
					buttonTexts={["Okay", "Cancel"]}
					buttonClickHandlers={[
						() => this.setToggleState(false),
						this.closeConfirm,
					]}
					onClose={this.closeConfirm}
				/>
			);
		}

		return (
			<div
				className={mainClass}
				onClick={this.onToggle}
				onKeyPress={this.onKeyPress}
			>
				<div className={styles.textOn}>On</div>
				<div className={styles.textOff}>Off</div>
				<div className={styles.circle} />
				{confirmModal}
			</div>
		);
	},
});
